import { Box, Divider, Grid, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { Modal, Card, IconButton, Chip } from 'components'
import { useStore } from 'store'
import { formatCurrency, formatDate } from 'utils'
import { History, Close } from '@mui/icons-material'
import { useLoadOrdersCustomerProductLastSale } from 'modules/orders/hooks/useLoadOrdersCustomerProductLastSale'

interface CustomerItemLastSales {
  CD_PEDIDO: string
  PR_UNITARIO: number
  DT_PEDIDO: string
}

type Props = {
  productId: string
}

export const LastSalesModal = ({ productId }: Props) => {
  const [lastSales, setLastSales] = useState<CustomerItemLastSales[]>([])
  const { stepOne } = useStore((state: any) => state.proposalForm)
  const [openLastSales, setOpenLastSales] = useState(false)

  const { data: lastSalesResponse } = useLoadOrdersCustomerProductLastSale({
    productId,
    customerId: stepOne?.customer?.id
  })

  useEffect(() => {
    setLastSales(lastSalesResponse?.data)
  }, [productId, lastSalesResponse?.data])

  return (
    <>
      <Chip
        label="Histórico"
        color="default"
        onClick={() => setOpenLastSales(true)}
        sx={{
          display: 'flex',
          justifyContent: 'center'
        }}
        icon={<History />}
      />

      <Modal
        open={openLastSales}
        onClose={() => {
          setOpenLastSales(false)
        }}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >
        <Card
          sx={{
            width: { xs: 350, sm: 400 }
          }}
        >
          <Box>
            <div
              style={{
                position: 'relative',
                overflowY: 'auto',
                height: 600
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: '1.5rem'
                }}
              >
                <Typography variant="subtitle1">ÚLTIMAS VENDAS</Typography>

                <IconButton
                  onClick={() => {
                    setOpenLastSales(false)
                  }}
                >
                  <Close />
                </IconButton>
              </div>
              {!lastSales?.length && (
                <Typography variant="subtitle2">
                  Não há vendas anteriores deste produto para este cliente!
                </Typography>
              )}
              {lastSales?.map((item: any) => (
                <div key={item.id}>
                  <Grid container spacing={1} mt={2}>
                    <Grid item xs={4}>
                      <Typography variant="caption" gutterBottom>
                        Pedido
                      </Typography>
                      <Typography style={{ fontSize: 14, fontWeight: 500 }}>
                        {item.orderId}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="caption" gutterBottom>
                        Data
                      </Typography>
                      <Typography style={{ fontSize: 14, fontWeight: 500 }}>
                        {formatDate(item.orderDate)}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="caption" gutterBottom>
                        Total
                      </Typography>
                      <Typography style={{ fontSize: 14, fontWeight: 500 }}>
                        {formatCurrency(item.totalItem)}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="caption" gutterBottom>
                        Preço Unitário
                      </Typography>
                      <Typography style={{ fontSize: 14, fontWeight: 500 }}>
                        {formatCurrency(item.salePrice)}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="caption" gutterBottom>
                        Desconto
                      </Typography>
                      <Typography style={{ fontSize: 14, fontWeight: 500 }}>
                        {item.discountPercent}%
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="caption" gutterBottom>
                        Quantidade
                      </Typography>
                      <Typography style={{ fontSize: 14, fontWeight: 500 }}>
                        {item.quantity}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                </div>
              ))}
            </div>
          </Box>
        </Card>
      </Modal>
    </>
  )
}
